import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-columns" }
const _hoisted_2 = { class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway" }
const _hoisted_3 = { class: "row col-xs-4 justify-end" }
const _hoisted_4 = { class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway" }
const _hoisted_5 = { class: "row col-xs-4 justify-end" }
const _hoisted_6 = { class: "row wrap col-xs-12" }

import { computed, onMounted, ref } from 'vue';
import Draggable from 'vuedraggable';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import { CatalogsApi } from 'SharedDir/backend/api';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';
import { HandsontableCellType, HandsontableCellTypes } from 'SharedDir/constants/field-types';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import {
  HeaderCellType,
  LabeledTableColumnType,
  TableColumnType,
} from 'SharedDir/declarations/fields';
import HeaderRowItem from 'SharedDir/service/fields/_Table/HeaderRow.vue';
import TableColumnItem from 'SharedDir/service/fields/_Table/TableColumn.vue';
import HeaderCell from 'SharedDir/service/fields/_Table/header-cell';
import TableColumn from 'SharedDir/service/fields/_Table/table-column';

export type TableColumnsType = {
  columns: Array<TableColumn>;
  headers: Array<Array<HeaderCell>>;
};

export interface Props extends PropValue<null | TableColumnsType> {
  readonly?: boolean;
  label?: string;
  /**
   * Флаг, что первый столбец не должен участвовать в суммировании.
   * И будет всегда строкойю
   */
  dontSumFirst?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TableColumnsParameter',
  components: {
    TableColumnItem,
    HeaderRowItem,
    Draggable,
  },
},
  __name: 'TableColumns',
  props: {
    readonly: { type: Boolean, default: false },
    label: {},
    dontSumFirst: { type: Boolean, default: false },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const castValue = (
  value: null | {
    columns: Array<TableColumnType>;
    headers: Array<Array<HeaderCellType>>;
  }
): TableColumnsType => {
  const { columns, headers } = value || { columns: [], headers: [] };
  const castedColumns = columns.map((column) => new TableColumn(column));
  const castedHeaders = headers.map((headersRow) =>
    headersRow.map((headerCell, order) => new HeaderCell({ ...headerCell, order }))
  );
  return {
    columns: castedColumns,
    headers: castedHeaders,
  };
};


const delayTooltip = DELAY_TOOLTIP;

const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits, { transform: castValue });

const labeledColumns = computed((): Array<LabeledTableColumnType> => {
  const columnHeaders: Record<number, string> = {};
  if (innerValue.value.headers.length > 0) {
    // Поскольку наличие столбцов не означает наличие заголовков к ним,
    // то по умолчанию будем использовать в качестве подписи slug.
    // Однако все равно проверим заголовки и будем искать в последней
    // строке одинарные заголовки и
    // назначать подпись соответствующим по порядку и colspan'у столбцам.
    const lastHeader = innerValue.value.headers[innerValue.value.headers.length - 1];
    let columnIndex = 0;
    for (let i = 0; i < lastHeader.length; i += 1) {
      const { colspan, label } = lastHeader[i];
      if (colspan === 1 || !colspan) {
        columnHeaders[columnIndex] = label;
        columnIndex += 1;
      } else {
        columnIndex += colspan;
      }
    }
  }
  const columns = innerValue.value.columns.map((column, index) => {
    let label: string = column.slug;
    if (columnHeaders[index]) {
      label = `${columnHeaders[index]} (${column.slug})`;
    }
    return { ...column, label };
  });
  return columns;
});

const addColumn = () => {
  innerValue.value.columns.push(new TableColumn({ order: innerValue.value.columns.length }));
  emitValue();
};

const addHeaderRow = () => {
  innerValue.value.headers.push([]);
  emitValue();
};

const removeColumn = (i: number) => {
  innerValue.value.columns.splice(i, 1);
  emitValue();
};

const removeHeaderRow = (i: number) => {
  innerValue.value.headers.splice(i, 1);
  emitValue();
};

const refreshColumnsOrder = () => {
  innerValue.value.columns.forEach((column, index) => {
    // eslint-disable-next-line no-param-reassign
    column.order = index;
  });
  if (props.dontSumFirst) {
    // При включенном режиме исключения первого столбца из суммы
    // при изменении порядка столбцов необходимо первый исключать
    // из все сумм.
    const [{ slug: firstColumnSlug }] = innerValue.value.columns;
    innerValue.value.columns.forEach((column) => {
      if (Array.isArray(column.summedColumns)) {
        column.summedColumns = column.summedColumns.filter((slug) => slug !== firstColumnSlug);
      }
    });
  }
  emitValue();
};

const refreshHeadersOrder = () => {
  emitValue();
};

/**
 * Для некоторых ситуаций необходимо, что бы первый столбец в таблице был всегда строго строкой.
 * Например, для настройки динамических таблиц. Где в отличие от статических таблиц.
 * Данная компонента используется для настройки всех колонок таблицы, включая первую.
 * @param index
 */
function getColumnTypes(index: number) {
  if (props.dontSumFirst && index === 0) {
    return HandsontableCellTypes.filter(({ value }) => value !== HandsontableCellType.numeric);
  }

  return HandsontableCellTypes;
}

const catalogs = ref([] as Catalogs.Catalogs[]);

onMounted(async () => {
  catalogs.value = await CatalogsApi.getAll();
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row col-xs-8 justify-start items-center s-text-title" }, "Столбцы таблицы", -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.readonly)
          ? (_openBlock(), _createBlock(SBtn, {
              key: 0,
              type: "brand",
              icon: "add",
              onClick: addColumn
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "content-class": "s-tooltip",
                  delay: _unref(delayTooltip)
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Добавить столбец таблицы ")
                  ])),
                  _: 1
                }, 8, ["delay"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(Draggable), {
      modelValue: _unref(innerValue).columns,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).columns) = $event)),
      tag: "div",
      "item-key": "order",
      class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway",
      "ghost-class": "section-field__item--ghost",
      "draggable-class": "section-field__item--draggable",
      animation: "200",
      disabled: _ctx.readonly,
      easing: "cubic-bezier(1, 0, 0, 1)",
      onEnd: refreshColumnsOrder
    }, {
      item: _withCtx(({ index: i }) => [
        _createVNode(TableColumnItem, {
          modelValue: _unref(innerValue).columns[i],
          "onUpdate:modelValue": [($event: any) => ((_unref(innerValue).columns[i]) = $event), _unref(emitValue)],
          class: "base-margin-bottom",
          readonly: _ctx.readonly,
          "all-columns": labeledColumns.value,
          catalogs: catalogs.value,
          "column-types": getColumnTypes(i),
          onRemove: ($event: any) => (removeColumn(i))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "all-columns", "catalogs", "column-types", "onRemove"])
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-xs-12 s-divider--dashed base-margin-bottom" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row col-xs-8 justify-start items-center s-text-title" }, "Заголовки таблицы", -1)),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.readonly)
          ? (_openBlock(), _createBlock(SBtn, {
              key: 0,
              type: "brand",
              icon: "add",
              onClick: addHeaderRow
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "content-class": "s-tooltip",
                  delay: _unref(DELAY_TOOLTIP)
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Добавить заголовок таблицы ")
                  ])),
                  _: 1
                }, 8, ["delay"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(Draggable), {
      modelValue: _unref(innerValue).headers,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).headers) = $event)),
      tag: "div",
      "item-key": "order",
      class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway",
      "ghost-class": "section-field__item--ghost",
      "draggable-class": "section-field__item--draggable",
      animation: "200",
      disabled: _ctx.readonly,
      easing: "cubic-bezier(1, 0, 0, 1)",
      onEnd: refreshHeadersOrder
    }, {
      item: _withCtx(({ index: i }) => [
        _createVNode(HeaderRowItem, {
          modelValue: _unref(innerValue).headers[i],
          "onUpdate:modelValue": [($event: any) => ((_unref(innerValue).headers[i]) = $event), _unref(emitValue)],
          class: "base-margin-bottom",
          index: i,
          readonly: _ctx.readonly,
          "max-colspan": _unref(innerValue).columns.length,
          onRemove: ($event: any) => (removeHeaderRow(i))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "index", "readonly", "max-colspan", "onRemove"])
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-xs-12 s-divider--dashed base-margin-bottom" }, null, -1)),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue).headers, (headerRow, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "row no-wrap col-xs-12"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerRow, (headerCell, j) => {
            return (_openBlock(), _createElementBlock("div", {
              key: j,
              class: _normalizeClass(`table-header table-header-${headerCell.colspan}`)
            }, _toDisplayString(headerCell.label), 3))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue).columns, (column, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "table-column"
          }, _toDisplayString(column.slug), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})